import { useEffect, useState } from 'react';
import { RotateCcw } from 'lucide-react';
import { isIosPhone } from '../../features/install/utils.js';

export function PortraitOnlyGuard() {
  const [showLandscapeWarning, setShowLandscapeWarning] = useState(false);

  useEffect(() => {
    if (!isIosPhone()) return undefined;

    const update = () => {
      const isLandscape = window.matchMedia('(orientation: landscape)').matches;
      const isVideoOpen = document.documentElement.classList.contains('video-fullscreen-open');
      setShowLandscapeWarning(isLandscape && !isVideoOpen);
    };

    update();
    window.addEventListener('orientationchange', update);
    window.addEventListener('resize', update);

    const landscapeQuery = window.matchMedia('(orientation: landscape)');
    landscapeQuery.addEventListener('change', update);

    return () => {
      window.removeEventListener('orientationchange', update);
      window.removeEventListener('resize', update);
      landscapeQuery.removeEventListener('change', update);
    };
  }, []);

  if (!showLandscapeWarning) return null;

  return (
    <div className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-brand px-8 text-center text-white md:hidden">
      <RotateCcw className="mb-4 h-12 w-12 text-accent-peach" />
      <p className="text-xl font-bold">Rotate your phone</p>
      <p className="mt-2 text-sm text-white/85">
        Yocas works best in portrait mode. Rotate back to continue.
      </p>
    </div>
  );
}
